import { render } from "./PlayerTable.vue?vue&type=template&id=48c4f957&scoped=true"
import script from "./PlayerTable.vue?vue&type=script&lang=js"
export * from "./PlayerTable.vue?vue&type=script&lang=js"

import "./PlayerTable.vue?vue&type=style&index=0&id=48c4f957&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\game-forecast\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c4f957"]])

export default __exports__